export default {
  allReferrals: null,
  referralDetailsBySlug: {},
  referralDetailsError: null,
  referrer: null,
  referrerLoading: null,
  meta: null,
  loading: null,
  error: null,
  referEmailsLoading: false,
  referralInvite: {
    emails: [],
    is_anonymous: false
  }
};
